import {
  BarSeriesModule,
  CategoryAxisModule,
  GroupedCategoryAxisModule,
  LegendModule,
  LineSeriesModule,
  ModuleRegistry as ChartsCommunityModuleRegistry,
  NumberAxisModule,
} from 'ag-charts-community';
import {
  LicenseManager as ChartsEnterpriseLicenseManager,
  RadialGaugeModule,
} from 'ag-charts-enterprise';
import {
  AllCommunityModule,
  ModuleRegistry as GridCommunityModuleRegistry,
} from 'ag-grid-community';
import {
  ColumnsToolPanelModule,
  LicenseManager as GridEnterpriseLicenseManager,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  SetFilterModule,
  SideBarModule,
} from 'ag-grid-enterprise';

export const registerAgChartsAndGrids = (license: string) => {
  GridCommunityModuleRegistry.registerModules([
    AllCommunityModule,
    ColumnsToolPanelModule,
    ServerSideRowModelApiModule,
    ServerSideRowModelModule,
    SetFilterModule,
    SideBarModule,
  ]);

  ChartsCommunityModuleRegistry.registerModules([
    BarSeriesModule,
    LineSeriesModule,
    CategoryAxisModule,
    NumberAxisModule,
    LegendModule,
    RadialGaugeModule,
    GroupedCategoryAxisModule,
  ]);

  GridEnterpriseLicenseManager.setLicenseKey(license);
  ChartsEnterpriseLicenseManager.setLicenseKey(license);
};
